import { MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = [
    '$scope', '$window', 'Util',
];

class OODiskimagePageController {

    constructor($scope, $window, Util) {

        this.$scope = $scope;
        this.$window = $window;
        this.$scope.userCountry = MeRepository.getMyUser().attributes.country;
        this.navigator = Util.getDeviceNavigator();
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        Mixpanel.send('ConnectWeb Store Open', {
            Source: 'Direct',
            Store: 'OO Diskimage Page',
        });

    }

    buy() {

        Mixpanel.send('ConnectWeb Store Buy Click', {
            'Product ID': 'odsk0',
            Page: 'OO Diskimage Store Page',
        });

        const eshopUrl = (this.$scope.userCountry === 'US' || this.$scope.userCountry === 'CA')
            ? 'https://shop.avira.com/819/purl-oodi_30?x-a-source=cw' : 'https://shop.avira.com/30/purl-oodi_30?x-a-source=cw';

        if (this.navigator === 'ios') {

            this.$window.location.href = eshopUrl;

        } else {

            this.$window.open(eshopUrl, '_blank');

        }

    }

}

class OODiskimagePageDirective {

    constructor() {

        this.template = require('./oo-diskimage-page.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, $window, Util) =>
            new OODiskimagePageController($scope, $window, Util));
        this.controller = _controllerDependencies;
        this.controllerAs = 'ooDiskimagePageCtrl';

    }

}

_directiveDependencies.push(() => new OODiskimagePageDirective());


angular.module('directives')
    .directive('ooDiskimagePage', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/oo-diskimage-page/oo-diskimage-page.js